import styled from 'styled-components';

import colors from '~/styles/colors';
import grid from '~/styles/grid';

interface ContainerProps {
  status?: string;
}

// TODO(Micheal): retornar cores corretas
const handleBackgroundColor = (status: string) => {
  switch (status) {
    case 'Finalizado':
      return '#fff';
    case 'Não iniciado':
      return '#fff';
    case 'Em andamento':
      return '#fff';
    case 'Erro':
      return '#fff';
    default:
      return '#fff';
  }
};

export const Container = styled.div<ContainerProps>`
  display: grid;
  grid-template-columns: auto 18px;
  padding: ${grid.md};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;

  background-color: ${(props) =>
    props.status && handleBackgroundColor(props.status)};
`;

export const TextContent = styled.div``;

export const Title = styled.h2`
  color: ${colors.primary} !important;
  font-size: 126.57% !important;
  font-weight: 400;
  margin-bottom: ${grid.xs};
`;

export const Body = styled.span`
  font-size: 85.71% !important;
  color: #4d4d4d;
  font-weight: 600;
`;

export const DownloadContent = styled.div`
  align-self: center;
`;
